module.exports = __webpack_public_path__ + "img/tags-icon.a98fa765.png";